import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';

interface ComponentProps {}

const ModulesPage: React.FC<ComponentProps> = () => {
  return (
    <>
      <AdminLayout title="Module settings">Use companies and detail</AdminLayout>
    </>
  );
};

export default withAuthenticationRequired(ModulesPage);
